import { AlertTriangle } from 'lucide-react';

export const RiskWarningBanner = () => {
  return (
    <div className="w-full bg-red-50 border-y border-red-200 px-4 py-2.5" data-testid="risk-warning-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
        <AlertTriangle className="w-3.5 h-3.5 text-red-700 shrink-0" />
        <p className="text-xs font-medium text-red-800 text-center">
          <strong>Risk Warning:</strong> Trading leveraged financial instruments involves a high level of risk and may not be suitable for all investors. You may lose more than your initial investment. Make sure you have taken independent advice before engaging in any trading activities.
        </p>
      </div>
    </div>
  );
};
